/**
 * Utility function to send postMessage to parent window or React Native WebView
 *
 * @param message - The message object to send (will be stringified)
 * @param targetOrigin - The target origin for window.parent.postMessage (defaults to "*" for iframe compatibility)
 */
export const sendPostMessage = (
  message: Record<string, any>,
  targetOrigin: string = "*"
): void => {
  const messageString = JSON.stringify(message);

  // Check if running in React Native WebView
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(messageString);
  } else {
    // Running in iframe/web context - send to parent window
    window.parent.postMessage(messageString, targetOrigin);
  }
};
